<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-09 15:30:41
-->
<template>
  <div class="login-out" @click="loginOut">退出登录</div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    loginOut () {
      this.$confirm('是否退出登录', '提示', {}).then(() => {
        const searchParams = sessionStorage.getItem('searchParams')
        localStorage.clear()
        sessionStorage.clear()
        this.$router.replace(`${searchParams}`)
      }).catch(() => {})
    }
  }
}
</script>
<style scoped lang="scss">
  .login-out {
    width: 140px;
    height: 55px;
    background: #F04037;
    border-radius: 0px 0px 10px 10px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
    line-height: 55px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/LoginOut.vue